import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreActions: {
		id: 'software-backlog-panel.card.context-menu.more-actions',
		defaultMessage: 'More actions',
		description: 'Label for the context menu button that shows more actions for a card',
	},
});
